import React, { useState } from 'react';
import ToolkitBatchPage from './toolkit/ToolkitBatchPage';
import { sourceRow } from './toolkit/useToolkitBatch';

// Sync › project › Toolkit › CheckIn — ported from the desktop's OHIP › CheckIn. Each reservation in a v5 arrivals list
// is checked in to the room on the file, found by its v5 confirmation number (toolkit property.js check-in). Optionally
// the room is set Vacant / Inspected first. Missing reservations, and ones already checked in, are skipped.

const COLUMNS = [
    { key: 'CONFIRMATION_NO', label: 'Confirmation' },
    { key: 'GUEST_NAME', label: 'Guest' },
    { key: 'ROOM', label: 'Room' },
    { key: 'ARRIVAL', label: 'Arrival' },
    { key: 'DEPARTURE', label: 'Departure' },
    { key: 'RESV_STATUS', label: 'v5 status' },
    { key: 'result', label: 'Result' },
];

function ToolkitCheckInPage() {
    const [setInspected, setSetInspected] = useState(false);
    const request = (row) => ({ area: 'property', op: 'check-in', args: { v5Record: sourceRow(row, ['result']), setInspected } });
    return (
        <ToolkitBatchPage title="CheckIn"
            subtitle="Check reservations in to their rooms in Opera Cloud from an Opera v5 arrivals list."
            fileTitle="Opera v5 arrivals list" fileLabel="Choose the check-in file (CSV / pipe)" accept=".csv,.txt"
            kind="check-ins" columns={COLUMNS} searchKeys={['CONFIRMATION_NO', 'GUEST_NAME', 'ROOM']} exportName="Check_In"
            request={request} server={{ screen: 'check-in', title: 'CheckIn', keyOf: (row) => row.CONFIRMATION_NO }}
            options={(
                <label className="tkb-check">
                    <input type="checkbox" checked={setInspected} onChange={(e) => setSetInspected(e.target.checked)} />
                    <span>Set each room Vacant / Inspected before checking in</span>
                </label>
            )} />
    );
}

export default ToolkitCheckInPage;
